import ContentReveal from '../content-reveal'

export default class BlockImage extends ContentReveal {
	static title = 'block-image'

	// the shape half of the block-image--<shape>-<caption position> modifier
	static shapes = ['square', 'portrait', 'landscape', 'circle']

	// the caption positions that reveal their caption on scroll, inside flips on hover instead
	static positions = ['above', 'below']

	canReveal() {
		return BlockImage.positions.some((position) =>
			BlockImage.shapes.some((shape) =>
				this.$el.hasModifier(`${shape}-${position}`),
			),
		)
	}
}
